<template>
  <el-dialog :visible="showModal" width="80%" :show-close="false" :modal-append-to-body="false" @close="$emit('close')">
    <div class="header">
      <div class="header-title">
        {{ propsData.date }} 充电站销量统计明细
      </div>
      <div @click="showModal = false;" class="header-close"><i class="el-icon-close"></i></div>
    </div>
    <div class="charge-data-detail">
      <div class="detail-title">
        <div>站点明细</div>
        <div style="display: flex">
          <el-date-picker   value-format="yyyy-MM-dd" :pickerOptions="pickerOptions" style="border: 2px solid #0CC874;;margin-right: 100px;width: 600px;height: 60px;font-size: 26px" v-model="exportDataDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          <el-button style="width: 300px;height: 60px;font-size: 26px;" type="success" @click="exportBiclyData">导出数据</el-button>
        </div>
      </div>
      <div class="detail-table">
        <div class="table-main">
          <el-table
              :data="dataList.slice((currentPage - 1)*pageSize,currentPage*pageSize)"
              @sort-change="softCharge"
              border
              style="width: 100%">

            <el-table-column label="序号" width="100px" align="left">
              <template slot-scope="scope">
                {{ (scope.$index+1)+(currentPage-1)*pageSize }}
              </template>
            </el-table-column>

            <el-table-column
                prop="station_name"
                width="700px"
                label="充电站名称"
                sortable="custom"/>

            <el-table-column
                prop="station_code"
                width="300px"
                label="站点编号"
                sortable="custom"/>

            <el-table-column
                prop="total_power"
                label="充电量（kwh）"
                sortable="custom"/>

            <el-table-column
                prop="total_elec_money"
                label="电费（元）"
                sortable="custom"
            />
            <el-table-column
                prop="amount"
                label="合计（元）"
                sortable="custom"/>
          </el-table>

          <el-pagination
              @current-change="changePage"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="dataList.length">
          </el-pagination>

          <el-table :data="totalStatistics" style="width: 100%;margin-top: 20px">
            <el-table-column prop="name" width="700px" label="" >
            </el-table-column>

            <el-table-column prop="code" width="300px" label="" >
            </el-table-column>

            <el-table-column label="合计（kwh）" prop="statistics1" >
              <template slot-scope="scope">
                {{scope.row.statistics1}} kwh
              </template>
            </el-table-column>

            <el-table-column label="合计(元)" prop="statistics2" >
              <template slot-scope="scope">
                {{scope.row.statistics2}} 元
              </template>
            </el-table-column>

            <el-table-column label="总计（元）" prop="statistics4" >
              <template slot-scope="scope">
                {{scope.row.statistics4}} 元
              </template>
            </el-table-column>
          </el-table>

        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { Loading } from "element-ui";

export default {
  name: "ModalXLTJ_Charge",
  data() {
    return {
      showModal: false,
      propsData: {},
      detailData: {},
      dataList: [],
      count: 0,
      pageSize: 16,
      currentPage: 1,
      exportDataDate: [ this.formatDate(new Date()), this.formatDate(new Date())],
      totalStatistics:[],
      pickerOptions:  {
        disabledDate: (time) => {
          if (this.exportDataDate && this.exportDataDate[0]) {
            const startDate = new Date(this.exportDataDate[0]);
            const minDate = new Date(startDate);
            minDate.setDate(minDate.getDate() - 30);
            const maxDate = new Date(startDate);
            maxDate.setDate(maxDate.getDate() + 30);
            return time.getTime() < minDate.getTime() || time.getTime() > maxDate.getTime();
          }
          return false;
        },
        onPick: ({ maxDate, minDate }) => {
          if (minDate && !maxDate) {
            this.$nextTick(() => {
              this.exportDataDate = [minDate, minDate];
            });
          }
        }
      }
    };
  },
  methods: {
    open(data) {
      this.propsData = data;
      const loading = Loading.service({
        lock: true,
        text: "正在加载..",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      Promise.allSettled([this.getData()]).then(() => {
        loading.close();
        this.showModal = true;
      });
    },
    changePage(page) {
      this.currentPage = page;
    },
    getData() {
      return new Promise(resolve => {
        this.$api.getBicycleOrderStatistics({ ...this.propsData})
            .then(res => {
              this.count = res.data.count;
              this.dataList = res.data.dataList;
              this.totalStatistics =[];
              this.totalStatistics.push({
                name:"",
                code:"",
                statistics1:res.data.totalPower,
                statistics2:res.data.totalElecMoney,
                statistics4:res.data.totalAmount
              })
              resolve();
            });
      });
    },
    //排序
    softCharge(soft){
      console.log(soft);
      let prop = soft.prop;
      let order = soft.order;
      //升序
      if(order === 'ascending'){
        this.dataList.sort((a, b) => a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0);
      }
      //降序
      if(order === "descending"){
        this.dataList.sort((a, b) => a[prop] < b[prop] ? 1 : a[prop] > b[prop] ? -1 : 0) ;
      }
    },
    exportBiclyData(){
       const params = {startTime: this.exportDataDate[0],endTime: this.exportDataDate[1]};
       this.$api.exportBicycleData(params);
    },
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../style/_parameter.scss";

::v-deep.el-range-editor .el-range-input{
  font-size: 23px;
}


::v-deep.el-table .el-table__header-wrapper tr th {
  background-color: #0CC874;
}

::v-deep.el-date-editor .el-range-separator{
  font-size: 20px;
  margin-top: 18px;
}


::v-deep.el-table td, ::v-deep.el-table th {
  height: 90px;
  color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
}

::v-deep .el-table__body{
  pointer-events: none !important;
}
::v-deep.el-table .cell {
  line-height: 40px;
}

::v-deep.el-table .caret-wrapper{
  transform: scale(2);
  margin-left: 10px;
}

.header {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: -30px;
  box-sizing: border-box;
  padding: 0 30px;

  .header-title {
    font-size: 34px;
    color: rgb(181, 228, 255);
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .header-video-btn {
    font-size: 30px;
    font-weight: bold;
    color: #fff;
    margin-left: 60px;
    width: 220px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: solid 2px #fff;
    border-radius: 60px;
    cursor: pointer;

    i {
      font-size: 40px;
      margin-right: 10px;
    }

    &:hover {
      opacity: .8;
    }
  }


  .header-close {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background-color: $red;
    border-radius: 100%;

    i {
      font-size: 40px;
    }

    cursor: pointer;

    &:hover {
      opacity: .8;
    }
  }
}

.detail-title {
  font-size: 32px;
  font-weight: 500;
  margin-top: 30px;
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
}

.charge-data-detail {
  height: auto;
  box-sizing: border-box;
  padding: 40px;

  .detail-wrap {
    height: 384px;
    border-top: solid 2px #ccc;
  }

  .detail-left {
    float: left;
    width: 500px;
    height: 100%;
    box-sizing: border-box;
    padding: 30px;
    border-left: solid 2px #ccc;
    border-right: solid 2px #ccc;
    border-bottom: solid 2px #ccc;

    .detail-title {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      color: #D1D2D3;
      margin-bottom: 40px;
    }

    .detail-icon {
      margin: 0 auto;
      width: 260px;
      height: 260px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .detail-status {
      font-size: 30px;
      margin-top: 32px;
      text-align: center;

      &.green {
        color: #63CA2D;
      }

      &.red {
        color: #E6474A;
      }

      &.gray {
        color: #8E8E8E;
      }

      &.purple {
        color: #6B51FF;
      }
    }
  }

  .detail-main {
    float: left;
    width: calc(100% - 500px);
    height: 100%;
    box-sizing: border-box;

    .detail-row {
      float: left;
      width: 40%;
      height: 96px;

      &.width100 {
        width: 100%;

        .row-title, .row-content {
          width: 50%;
        }
      }

      &:nth-of-type(2n) {
        width: 60%;
      }

      box-sizing: border-box;

      .row-title {
        float: left;
        width: 360px;
        height: 96px;
        line-height: 96px;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        box-sizing: border-box;
        background: rgba(255, 255, 255, .1);
        padding: 0 30px;
        color: #CDCECF;
        font-size: 28px;
      }

      .row-content {
        float: left;
        width: calc(100% - 360px);
        height: 96px;
        line-height: 96px;
        padding: 0 30px;
        box-sizing: border-box;
        border-right: solid 2px #ccc;
        border-bottom: solid 2px #ccc;
        color: #BEBEC2;
        font-size: 28px;
        @extend .omit;
      }
    }
  }
}

.detail-table {
  position: relative;
  height: calc(100% - 522px);
  margin-top: 20px;

  .table-filter {
    height: 96px;
    margin-top: 30px;

    .filter-item {
      float: left;
      @extend .clearfix;
      width: 250px;
      transform: scale(2);
      margin-left: 130px;

      .filter-title {
        float: left;
        width: 80px;
        line-height: 38px;
        color: #BEBEC1;
      }

      .filter-content {
        float: left;
        width: calc(100% - 80px);
      }
    }
  }

  .table-main {
    height: calc(100% - 116px);

    * {
      font-size: 28px !important;
    }

    .el-table tbody tr {
      pointer-events: none;
    }

    .el-table thead {
      color: #fff;

      th.el-table__cell {
        background: transparent;
      }
    }

    .el-table .el-table__cell {
      padding: 25px;
    }

    .el-table .caret-wrapper {
      width: 34px;
      height: 54px;
    }

    .el-table .sort-caret {
      border-width: 10px;

      &.ascending {
        top: 0;
      }

      &.descending {
        bottom: 2px;
      }
    }
  }
}

::v-deep.el-pagination {
  margin-top: 50px;
}

::v-deep.el-pagination * {
  font-size: 28px !important;
}
</style>
